export default __webpack_public_path__ + "static/media/Understanding-moon.1d018d85.jpg";